import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Importar JSON directamente (esbuild y TypeScript con resolveJsonModule los bundlean)
import en from "./locales/en.json";
import es from "./locales/es.json";

i18next
    .use(LanguageDetector)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
        },
        fallbackLng: "en",
        supportedLngs: ["en", "es"],
        interpolation: { escapeValue: false },
        detection: {
            order: ["querystring", "navigator"],
            lookupQuerystring: "lang",
        },
    });

export default i18next;
export const t = (key: string, opts?: any): string => (i18next.t(key, opts) as string);
